import React from "react";
import {useDispatch} from "react-redux";
import {FmlxIcon} from "fmlx-common-ui";
import {PostRequest} from "../../../lib/AxiosHelper";
import {useManageQuestionContext} from "../../../lib/contexLib";
import {ALERT_VARIANT} from "../../../const/dataEnum";
import {API_ACTION, API_SKILL_CATEGORY} from "../../../const/Api";
import {FMLX_COMPONENT} from "../../../const/FmlxComponentEnum";
import {setAlert} from "../../../stores/actions/alertModalStateAction";
import NavItem from "./NavItem";
import skillCategoryBusiness from "../../../stores/business/skillCategoryBusiness";

const NavTabs = ({addNewTab, fetchTabs, reviewPeriodId}) => {
  const dispatch = useDispatch();
  const {selectedPractice, activeTab, setActiveTab, tabs, setTabs, selectedDepartment} = useManageQuestionContext();

  const handleTabClick = (key) => {
    let tempActiveTab = activeTab;
    let tempTabs = tabs.map((tab) => {
      if (tab.categoryOrder === key) {
        tempActiveTab = {...tab, active: true};
        return {...tab, active: true};
      } else {
        return {...tab, active: false};
      }
    });
    setActiveTab(tempActiveTab);
    setTabs(tempTabs);
  };

  const addTab = (value) => {
    const maxCategoryOrder = tabs.length > 0 
      ? Math.max(...tabs.map(tab => tab.categoryOrder || 0)) 
      : 0;
    const nextCategoryOrder = maxCategoryOrder + 1;
    
    let newTabData = value
      ? {
        category: value?.category,
        categoryOrder: nextCategoryOrder,
        description: value?.description,
        notes: value?.notes,
        practice: value?.practice,
        practiceId: value?.practiceId,
      }
      : {
        category: `New Category ${nextCategoryOrder}`,
        categoryOrder: nextCategoryOrder,
        description: "",
        notes: "",
        practice: null,
        practiceId: selectedPractice?.id,
      };

    addNewTab(newTabData);
  };

  const handleRename = (tabId, value) => {
    let tabToRename = tabs.find((tab) => tab.id === tabId);
    if (tabToRename) {
      const payload = {
        ...tabToRename,
        category: value,
        reviewPeriodId: reviewPeriodId,
      };
      delete payload.active;

      const url = `${API_SKILL_CATEGORY}/UpdateForPeriod`;

      PostRequest(dispatch, url, payload)
        .then((response) => {
          const {message, responseCode} = response.data;
          if (responseCode === 0) {
            fetchTabs();
          } else {
            dispatch(
              setAlert({
                show: true,
                variant: ALERT_VARIANT.ERROR,
                message: message,
              })
            );
          }
        })
        .catch((error) => {
          dispatch(
            setAlert({
              show: true,
              variant: ALERT_VARIANT.ERROR,
              message: error.data,
            })
          );
        })
        .finally(() => {
        });
    }
  };

  const deleteTab = async (key, index) => {
    if (index) {
      let tabToDel = tabs.filter((tab) => tab.categoryOrder === key);
      if (tabToDel.length !== 0) {
        const payload = {
          id: tabToDel[0].id,
          category: tabToDel[0].category,
          categoryOrder: tabToDel[0].categoryOrder,
          description: tabToDel[0].description,
          notes: tabToDel[0].notes,
          practiceId: tabToDel[0].practiceId,
          practice: {
            ...selectedPractice,
            department: selectedDepartment,
          }
        }
        const isSuccess = await dispatch(skillCategoryBusiness.deleteCategory(payload));
        if (isSuccess) {
          fetchTabs();
        }
      }
    } else {
      let tempTabs = tabs.filter((tab) => tab.id !== undefined);
      setTabs(tempTabs);
    }
  };

  return (
    <div className="manageQuestionPage-content-NavTabs tab_header">
      <div className="managequestion-tabwrapper">
        {tabs?.map((tab, index) => (
          <NavItem
            key={`tab-${tab.id || 'new'}-${tab.categoryOrder}-${index}`}
            tab={tab}
            handleTabClick={handleTabClick}
            handleRename={handleRename}
            addTab={addTab}
            deleteTab={deleteTab}
          />
        ))}
      </div>
      {selectedPractice && (
        <div className="add_tab" onClick={() => addTab("")}>
          <FmlxIcon name={"Add"} size={FMLX_COMPONENT.SIZE.S}/>
        </div>
      )}
    </div>
  );
};

export default NavTabs;
